import style from "@/pages-react/home-page/css/style.black-and-blue.module.scss";
import classNames from "classnames";
import { LogisticAndDelivery } from "@/elements-react/logistic-and-delivery";
import { FixBenefits } from "@/elements-react/fix-benefits";
import { B2BAdvertising } from "@/elements-react/b2b-advertising";
import { useHomeCommon } from "@/pages-react/home-page/home-page-common";
import { BrowseCategories } from "@/elements-react/browse-categories";
import { withCatalogLayout } from "@/elements-react/catalog-layout/withCatalogLayout";
import { MostBought } from "@/elements-react/most-bought";
import {LayoutStyleTypes} from "@/util-react/layout.tsx";
import {CarBrandsList} from "@/elements-react/car-brands-list";
import { FormSendList } from "@/elements-react/form-send-list";
import { FormFindPart } from "@/elements-react/form-find-part";

export const HomePageBlackAndBlueDesktop = withCatalogLayout(() => {
  const { topLevelCategories } = useHomeCommon();

  return (
    <>
      <div className={classNames(style.sections)}>
        <MostBought />
        <FixBenefits />
        <CarBrandsList type={LayoutStyleTypes.TYPE_LG} />
        <FormSendList />
        <LogisticAndDelivery />
        <B2BAdvertising />
        <BrowseCategories categories={topLevelCategories} />
        <FormFindPart />
      </div>
    </>
  );
});

export const HomePageBlackAndBlueMobile = withCatalogLayout(() => {
  const { topLevelCategories } = useHomeCommon();

  return (
    <>
      <div className={classNames(style.sectionsMobile)}>
        <MostBought />
        {/*<FixBenefits />*/}
        <FormSendList />
        <LogisticAndDelivery />
        <CarBrandsList type={LayoutStyleTypes.TYPE_SM} />
        {/*<B2BAdvertising />*/}
        {/*<BrowseCategories categories={topLevelCategories} />*/}
        <FormFindPart />
      </div>
    </>
  );
});
